// extracted by mini-css-extract-plugin
export default {"content":"MainContentWrapper_content__lbgKF"};